import {
  type MaterialDataObject,
  THREE
} from '@powerplay/core-minigames'
import {
  MaterialsNames,
  TexturesNames
} from '../types'

/**
 * Konfig pre materialy
 */
export const materialsConfig: MaterialDataObject = {

  [MaterialsNames.athlete]: {
    meshesArray: [
      'body_low', 'f_body_low'
    ],
    textureName: TexturesNames.athleteClothes,
    playerIndex: 0
  },
  [MaterialsNames.athleteHairTrack]: {
    meshesArray: [],
    transparent: true, // zatial davame vsetky transparentne
  },
  [MaterialsNames.javelin]: {
    textureName: TexturesNames.javelin,
    meshesArray: ['javelin', 'athlete_javelin_2']
  },
  [MaterialsNames.athleteHairClip]: {
    meshesArray: ['stipec_low'],
  },
  [MaterialsNames.audience]: {
    textureName: TexturesNames.audience,
    meshesArray: ['Stadium2_Collapsed_Mesh001_10'],
    lightmap: TexturesNames.envLightmap,
    alpha: 0.5, // alphatest
    transparent: true,
    vertexColors: true,
  },
  [MaterialsNames.audienceFlags]: {
    textureName: TexturesNames.flagsImages,
    meshesArray: ['AthleticStadium_Stadium2_Flags'],
    // lightmap: TexturesNames.envLightmap,
    vertexColors: true,
  },
  [MaterialsNames.colorGradient]: {
    textureName: TexturesNames.colorGradient,
    meshesArray: [
      'env_Stadium2_AdsJavelin', 'env_Stadium2_Screen2', 'env_Stadium2_Screen1',
      'Stadium2_Collapsed_Mesh001_4', 'Stadium2_100m_Mesh_1'
    ],
  },
  [MaterialsNames.concrete]: {
    textureName: TexturesNames.concrete,
    meshesArray: ['Stadium2_Collapsed_Mesh001_5', 'Stadium2_Collapsed_Mesh001_7', 'Stadium2_Collapsed_Mesh001_13'],
    lightmap: TexturesNames.envLightmap,
    vertexColors: true,
  },
  [MaterialsNames.glassPanel]: {
    textureName: TexturesNames.glassPanel,
    meshesArray: ['Stadium2_Collapsed_Mesh001_1'],
    lightmap: TexturesNames.envLightmap,
    transparent: true,
    vertexColors: true,
  },
  [MaterialsNames.grass]: {
    textureName: TexturesNames.grass,
    meshesArray: ['Stadium2_Collapsed_Mesh001_8'],
    lightmap: TexturesNames.envLightmap,
    vertexColors: true,
  },
  [MaterialsNames.hexCladding]: {
    textureName: TexturesNames.hexCladding,
    meshesArray: ['Stadium2_Collapsed_Mesh001'],
    lightmap: TexturesNames.envLightmap,
    vertexColors: true,
  },
  [MaterialsNames.metal]: {
    textureName: TexturesNames.metal,
    meshesArray: ['Stadium2_Collapsed_Mesh001_3', 'Stadium2_100m_Mesh'],
    lightmap: TexturesNames.envLightmap,
    vertexColors: true,
  },
  [MaterialsNames.panel]: {
    textureName: TexturesNames.panel,
    meshesArray: ['Stadium2_Collapsed_Mesh001_2'],
    lightmap: TexturesNames.envLightmap,
    vertexColors: true,
  },
  [MaterialsNames.sand]: {
    textureName: TexturesNames.sand,
    meshesArray: ['Stadium2_Collapsed_Mesh001_9'],
    lightmap: TexturesNames.envLightmap,
    vertexColors: true,
  },
  [MaterialsNames.seats]: {
    textureName: TexturesNames.seats,
    meshesArray: ['Stadium2_Collapsed_Mesh001_12'],
    lightmap: TexturesNames.envLightmap,
    vertexColors: true,
    alpha: 0.5, // alphatest
  },
  [MaterialsNames.stairs]: {
    textureName: TexturesNames.stairs,
    meshesArray: ['Stadium2_Collapsed_Mesh001_6'],
    lightmap: TexturesNames.envLightmap,
    vertexColors: true,
  },
  [MaterialsNames.npc]: {
    textureName: TexturesNames.npc,
    meshesArray: ['env_Stadium2_NPCJavelin'],
    lightmap: TexturesNames.envLightmap,
    vertexColors: true,
  },
  [MaterialsNames.lattice]: {
    textureName: TexturesNames.lattice,
    meshesArray: ['Stadium2_Collapsed_Mesh001_11'],
    lightmap: TexturesNames.envLightmap,
    alpha: 0.5,
    vertexColors: true,
  },
  [MaterialsNames.emissive]: {
    textureName: TexturesNames.emissive,
    meshesArray: ['env_Stadium2_Emissive'],
    alpha: 0.5, // alphatest
  },
  [MaterialsNames.numbers]: {
    textureName: TexturesNames.numbers,
    meshesArray: ['Stadium2_Collapsed_Mesh001_15'],
    lightmap: TexturesNames.envLightmap,
  },
  [MaterialsNames.lightFlashes]: {
    textureName: TexturesNames.lightFlashes,
    transparent: true,
    blending: THREE.AdditiveBlending,
    depthWrite: false,
    depthTest: false,
    meshesArray: ['env_LightFlash'],
  },
  [MaterialsNames.lightsGradient]: {
    textureName: TexturesNames.gradient,
    transparent: true,
    vertexColors: true,
    blending: THREE.AdditiveBlending,
    depthWrite: false,
    depthTest: false,
    meshesArray: ['envDynamic_Stadium2_Lightshafts'],
  },
  [MaterialsNames.onlyVertexColors]: {
    isDefault: true,
    meshesArray: [],
    vertexColors: true,
    lightmap: TexturesNames.envLightmap,
  },
  [MaterialsNames.lineRecord]: {
    meshesArray: ['envDynamic_Javelin_DynamicLine'],
    transparent: true,
    opacity: 0.7
  },

}
